/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { FormIntegrationQueryV1 } from '../models/form-integration-query-v-1';


/**
 * API for form integration operations
 */
@Injectable({
  providedIn: 'root',
})
export class V1FormIntegrationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getFormByIdV1
   */
  static readonly GetFormByIdV1Path = '/v1/integration/forms/{formId}';

  /**
   * Get a form definition by ID.
   *
   * Retrieves the form definition including the full structure, allowed values, and conditions.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFormByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFormByIdV1$Response(params: {
    formId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<FormIntegrationQueryV1>> {

    const rb = new RequestBuilder(this.rootUrl, V1FormIntegrationService.GetFormByIdV1Path, 'get');
    if (params) {
      rb.path('formId', params.formId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FormIntegrationQueryV1>;
      })
    );
  }

  /**
   * Get a form definition by ID.
   *
   * Retrieves the form definition including the full structure, allowed values, and conditions.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFormByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFormByIdV1(params: {
    formId: string;
  },
  context?: HttpContext

): Observable<FormIntegrationQueryV1> {

    return this.getFormByIdV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<FormIntegrationQueryV1>) => r.body as FormIntegrationQueryV1)
    );
  }

}
